import React from 'react';
import toast from 'react-hot-toast';
import {gql, CartProvider} from '@shopify/hydrogen';
import {Maintenance} from '~/components/global/Maintenance.client';

export function ClientWrapper({
  children,
  ...props
}: {
  children: React.ReactNode;
}) {
  if (import.meta.env.PUBLIC_MAINTENANCE === 'true') {
    return <Maintenance />;
  }

  return (
    <CartProvider
      {...props}
      cartFragment={cartFragment}
      onLineAddComplete={() => toast.success('Added to cart')}
    >
      {children}
    </CartProvider>
  );
}

const cartFragment = gql`
  fragment CartFragment on Cart {
    id
    checkoutUrl
    totalQuantity
    buyerIdentity {
      countryCode
      customer {
        id
        email
        firstName
        lastName
        displayName
      }
      email
      phone
    }
    lines(first: $numCartLines) {
      edges {
        node {
          id
          quantity
          attributes {
            key
            value
          }
          cost {
            totalAmount {
              amount
              currencyCode
            }
            compareAtAmountPerQuantity {
              amount
              currencyCode
            }
          }
          merchandise {
            ... on ProductVariant {
              id
              availableForSale
              compareAtPriceV2 {
                ...MoneyFragment
              }
              priceV2 {
                ...MoneyFragment
              }
              requiresShipping
              title
              image {
                ...ImageFragment
              }
              product {
                id
                handle
                vendor
                title
              }
              selectedOptions {
                name
                value
              }
            }
          }
        }
      }
    }
    cost {
      subtotalAmount {
        ...MoneyFragment
      }
      totalAmount {
        ...MoneyFragment
      }
      totalDutyAmount {
        ...MoneyFragment
      }
      totalTaxAmount {
        ...MoneyFragment
      }
    }
    note
    attributes {
      key
      value
    }
    discountCodes {
      code
    }
  }
  fragment MoneyFragment on MoneyV2 {
    currencyCode
    amount
  }
  fragment ImageFragment on Image {
    id
    url
    altText
    width
    height
  }
`;
